import axios from 'axios';
import { STORAGE } from '../constants';
import { LocalStorageService } from './local-storage.service';
import i18n from 'i18next';

const _HTTP_ = axios.create();

const getErrorStatus = (url: string): string => {
  const domain = url.substring(url.indexOf('//') + 2, url.indexOf('/', url.indexOf('//') + 2));
  const priorityMap: Record<string, string> = {
    'api.chatbridge.mx': 'Crítico',
    'dev-api.chatbridge.mx': 'Prioridad baja',
    'beta-api.chatbridge.mx': 'Prioridad media'
  };

  return priorityMap[domain] || 'Sin prioridad';
};

_HTTP_.interceptors.request.use((config) => {
  const token = LocalStorageService.get(STORAGE.TOKEN);
  const currentLanguage = i18n.language || 'es';
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  config.headers['x-lang'] = currentLanguage;
  return config;
});

_HTTP_.interceptors.response.use(
  async (response) => {
    return response.data;
  },
  async (error) => {
    const { statusCode } = error.response.data;
    const { message } = error.response.data;
    const { errorCode } = error.response.data;

    if (statusCode === 500) {
      try {
        if (error.config.url) {
          const parsedUrl = new URL(error.config.url);
          const hostname = parsedUrl.hostname;
          const errorStatus = getErrorStatus(error.config.url);
          const environment =
            errorStatus === 'Prioridad baja'
              ? 'Desarrollo'
              : errorStatus === 'Prioridad media'
                ? 'Beta'
                : 'Crítico';
          console.log(hostname);
          const telegramApiUrl = `https://api.telegram.org/bot8111102806:AAGKJKQlvsS0ScVlcKQ2Z67nbnV7o609DN0/sendMessage`;
          const message =
            `¡ Atención ! , EndPoint Error:\n\n` +
            `EndPoint: ${error.config.url}\n` +
            `Ambiente: ${environment}\n` +
            `Error: 500\n` +
            `Estado: ${errorStatus}\n` +
            `Message: ${error.response.data.message}\n\n` +
            `Verificar EndPoint`;

          const params = {
            chat_id: '-4533930463',
            text: message
          };
          await axios.post(telegramApiUrl, params);
        }
      } catch (telegramError) {
        console.error('Error al enviar mensaje a Telegram:', telegramError);
      }
    }
    return handleResponseCode(statusCode, message, errorCode);
  }
);

const handleResponseCode = (statusCode: number, errorMessage: string, errorCode: number) => {
  const t = i18n.t.bind(i18n);

  if (statusCode === 404) {
    return Promise.reject(t('errorCode.404'));
  }

  switch (errorCode) {
    case 500:
      if (errorMessage.toLowerCase() === 'sesión caducada') {
        window.location.replace('/auth/login');
        LocalStorageService.clear();
        return;
      }
      if (errorMessage === 'Internal server error') {
        errorMessage = t('errors.error-500');
      }
      return Promise.reject({
        status: errorMessage,
        error: t(`errorCode.${errorCode || '000'}`)
      });
    case 401:
      window.location.replace('/auth/login');
      LocalStorageService.clear();
      break;
    case 400:
      return Promise.reject({
        status: errorMessage,
        error: errorMessage
      });
    default:
      return Promise.reject({
        status: errorMessage,
        error: t(`errorCode.${errorCode || '000'}`)
      });
  }
};

export const HTTP = _HTTP_;
